<template>
  <div>

    <vx-card card-border class="mb-4" title="Documentación asociada a la operación" title-color="dark" collapseAction>
      <vx-card card-border class="mb-2" v-for="(documento, index) in documentos" :key="index">

          <vs-row>
            <vs-col vs-type="flex" vs-align="center" vs-w="4">
              <span class="text-lg"> {{ documento.fichero }} </span>
            </vs-col>
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="3">
              <vs-chip v-if="documento.valTipoDocumento !== undefined" color="warning">{{documento.valTipoDocumento.nombre}}</vs-chip>
            </vs-col>
            <vs-col vs-type="flex" vs-align="center" vs-w="4">
              <p>{{documento.descripcion}}</p>
            </vs-col>
            <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-w="1">
              <feather-icon class="mr-4 hover:text-primary cursor-pointer" @click="descargaDocumento(documento.id, documento.fichero)" icon="DownloadIcon"/>
            </vs-col>
          </vs-row>       

      </vx-card>
      <div class="vx-row w-full" v-if="documentos === undefined || documentos.length === 0">
        <div class="vx-col w-full">
          <vs-alert color="danger" icon-pack="feather" icon="icon-info">
            <span>No existe ningún documento asociado a esta operación.</span>
          </vs-alert>
        </div>
      </div>
    </vx-card>

    <!-- Reset Button -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mt-8 flex flex-wrap items-center justify-end">
        <vs-button class="ml-4 mt-2" type="border" color="warning" @click="reset_data">Cancelar</vs-button>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import operacionesStore from '@/store/gestion/operaciones/index.js'
import documentosStore from '@/store/gestion/documentos/index.js'

import VueLink from 'vue-link'

export default {
  name: 'OperacionesViewDocumentacion',
  components: {
    VueLink
  },
  data () {
    return {
      operacion: {},
      documentos: []
    }
  },
  methods: {
    reset_data () {
      this.$router.push({name: 'operaciones'})
    },
    async descargaDocumento (id, nombre) {
      await this.$store.dispatch('documentosStore/downloadDocumento', id)
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data], {type: response.headers['content-type']}))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', nombre)
          document.body.appendChild(link)
          link.click()
        })
        .catch((error) => {
          console.log('ERROR', error)
        })
    }
  },
  async created () {
    if (!operacionesStore.isRegistered) {
      this.$store.registerModule('operacionesStore', operacionesStore)
      operacionesStore.isRegistered = true
    }
    if (!documentosStore.isRegistered) {
      this.$store.registerModule('documentosStore', documentosStore)
      documentosStore.isRegistered = true
    }

    this.operacion = JSON.parse(JSON.stringify(this.$store.state.operacionesStore.operacion))
    this.documentos = JSON.parse(JSON.stringify(this.operacion.documentos))
  }
}
</script>

